export default [
  {
    path: '/umkm',
    name: 'umkm',
    component: () => import('@/views/umkm/Index.vue'),
    meta: {
      pageTitle: 'UMKM',
      requiresAuth: true,
      breadcrumb: [
        {
          text: 'UMKM',
          active: true,
        },
      ],
    },
  },
  {
    path: '/umkm-v2',
    name: 'umkm-v2',
    component: () => import('@/views/umkm-v2/Index.vue'),
    meta: {
      pageTitle: 'UMKM V2',
      requiresAuth: true,
      breadcrumb: [
        {
          text: 'UMKM',
          active: true,
        },
      ],
    },
  },
];
